import { Sentry } from '@/lib/sentry';

/**
 * Used by ErrorBoundary.componentDidCatch — Sentry's own window
 * `error`/`unhandledrejection` listeners (installed by `initSentry()` in
 * main.tsx) don't see React render-tree errors, so this is the one path
 * left that reports explicitly. A no-op without a configured DSN
 * (`Sentry.captureException` is safe to call either way).
 */
export function logClientError(message: string, stack?: string) {
  const error = new Error(String(message));
  if (stack) error.stack = String(stack).slice(0, 8000);

  Sentry.captureException(error);
}
